






























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import ConfigField from '../../../../ConfigField/ConfigField.vue'
import { Group, SelectFn } from '../logic/types'
import ListItemView from './ListItemView.vue'

@Component({
  components: {
    ListItemView,
    ConfigField
  },
})
export default class ListGroup extends Vue {
  @Prop() group!: Group

  @Prop() selectFn!: SelectFn
}
